import { EventEmitter, Injectable, output } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GlobalService {
  shouldShowFooterCTA = new EventEmitter<boolean>();

  showFooterCTA() {
    this.shouldShowFooterCTA.emit(true);
  }
  hideFooterCTA() {
    this.shouldShowFooterCTA.emit(false);
  }
}
